import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ProxyContext } from '@app/core/enums/proxy-context.enum';
import { ResponseStatus } from '@app/core/enums/response-status.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { HttpRequestService } from '@app/core/services/http-request.service';
import { LoggerService } from '@app/core/services/logger.service';
import { SaveObjectInLocalServiceService } from '@app/core/services/save-object-in-local-service.service';
import { Observable } from 'rxjs';
import { AuthenticationCommand } from '../commands/authentication.command';
import { RecoverPasswordCommand } from '../commands/recover-password.command';
import { ResendEmailValidation } from '../commands/resend-email-verification.command';
import { SendCodeCommand } from '../commands/sendcode.command';
import { SetStoreCommand } from '../commands/setstore.command';
import { ValidateAccountCommand } from '../commands/validate-account-command';
import { AppProfile } from '@app/core/enums/app-profile.enum';
const logger = new LoggerService('AuthenticationService');

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
    private readonly requestService: HttpRequestService,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly storage: SaveObjectInLocalServiceService
  ) {}

  /**
   * Authenticates the user.
   *
   * @param context - The login parameters.
   * @returns The user credentials.
   */
  login(authCommand: AuthenticationCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.Autentication, authCommand);
  }

  /**
   * Logs out the user and clear credentials.
   *
   * @returns True if the user was logged out successfully.
   */
  getPolicisAccep(validateAccountCommand: ValidateAccountCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.PolicisPolicy, validateAccountCommand);
  }
  /**
   * Logs out the user and clear credentials.
   *
   * @returns True if the user was logged out successfully.
   */
  logout(): Observable<HttpServerResponse<any>> {
    // INFO: Logout Event implementation
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.AutenticationLogout, null);
  }

  getAllStoreCatalogs() {
    return this.requestService.get<HttpServerResponse<any>>(ProxyContext.GetAllStoreCatalogs);
  }

  snedCodeConfirmation(sencDodeCommand: SendCodeCommand) {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.AuthenticationSendCodeConfirm, sencDodeCommand);
  }

  validateAccoundsendEmail(command: ResendEmailValidation): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.SendEmailValidateAccount, command);
  }

  seelctStoreByLocation(command: SetStoreCommand): Observable<HttpServerResponse<any>> {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.SetStoreProcess, command);
  }

  recoverPassword(sencDodeCommand: RecoverPasswordCommand) {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.AuthenticationRecoverPassword, sencDodeCommand);
  }

  validateAccount(validateAccountCommand: ValidateAccountCommand) {
    return this.requestService.post<HttpServerResponse<any>>(ProxyContext.VerifiedAccount, validateAccountCommand);
  }

  validateAccountIsLogued() {
    return this.requestService.get<HttpServerResponse<any>>(ProxyContext.ValidateLogued, null, { useCache: false });
  }

  validateLogued(error: any) {
    logger.debug(error);
    this.validateAccountIsLogued().subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          if (!response.data.islogued) {
            this.storage.removeObject('persistenceSession');
            this.storage.removeObject('session');
            this.storage.removeObject('store');
            // winddw.location.href = '/authentication/login' commend;
            this.snackBar.open('No estás auntenticado.', '', { duration: 10000 });
            window.location.href = './authentication/login';
          }
        }
      },
      error: (e) => {
        logger.debug('process fail', e);
      },
      complete: () => {
        logger.debug('validateLogued process complete');
      }
    });
  }

  getRolSession(): string {
    let role: string = '';
    logger.debug(this.storage.getObject('session'));
    logger.debug(this.storage.getObject('profile'));
    const session = this.storage.getObject('session') as string;
    role = session.split('|')[3];
    return role;
  }

  /**
   * Obtiene el perfil del usuario logueado
   *
   * @returns Current user profile
   */
  getProfileSession(): AppProfile {
    const profile: AppProfile = this.storage.getObject('profile') as AppProfile;
    return profile;
  }

  getUserNameSession(): string {
    let username: string = '';
    const session = this.storage.getObject('session') as string;
    username = session.split('|')[2];
    return username;
  }

  validateIsLogued(): boolean {
    const sessionModel: AuthenticationCommand = JSON.parse(JSON.stringify(sessionStorage.getItem('session'))) as AuthenticationCommand;
    return sessionModel !== null || sessionModel !== undefined;
  }

  getCookie(nameCokkie: string): string | null {
    const match = document.cookie.match(new RegExp(`(^| )${nameCokkie}=([^;]+)`));
    if (match) {
      return match[2];
    } else {
      return null;
    }
  }
}
